export default __webpack_public_path__ + "static/media/artesanias de san juan de oriente.a2814a0e.png";